<template>
  <div class="wrapper">
    <b-container id="login">
      <form class="login-form" v-if="step == 0" @submit.prevent="findUser">
        <div class="form-item text-center forget-title">
          <span>Бүртгэл хайх</span>
          <p style="margin-bottom: 25px">
            Картын дугаар эсвэл утасны дугаарын зөвхөн нэгийг оруулна уу
          </p>
        </div>
        <div class="business-checkbox">
          <div>
            <input
              type="radio"
              id="personal"
              :value="false"
              v-model="isBusiness"
            />
            <label for="personal" class="required">Бонус карт</label>
          </div>
          <div>
            <input
              type="radio"
              id="business"
              :value="true"
              v-model="isBusiness"
            />
            <label for="business" class="required">Бизнес карт</label>
          </div>
        </div>
        <div class="form-item">
          <input
            type="text"
            class="form-control"
            v-model="phoneNumber"
            placeholder="Утасны дугаар"
            autofocus
          />
        </div>
        <div class="form-item">
          <input
            type="text"
            class="form-control margin-top"
            v-model="cardId"
            placeholder="Картын дугаар"
          />
        </div>
        <div class="forget-form">
          <div class="myRegister" v-if="isBusiness">
            <input
              type="text"
              class="form-control col-md-8"
              v-model="userRegister"
              placeholder="Регистрийн дугаар"
            />
          </div>
          <div class="myRegister" v-else>
            <select
              class="form-control col-md-2"
              name="registerNo1"
              v-model="registerNo1"
            >
              <option
                v-for="data in letters"
                :value="data.value"
                :key="data.value"
              >
                {{ data.name }}
              </option>
            </select>
            <select
              class="form-control col-md-2"
              name="registerNo2"
              v-model="registerNo2"
            >
              <option
                v-for="data in letters"
                :value="data.value"
                :key="data.value"
              >
                {{ data.name }}
              </option>
            </select>
            <input
              type="text"
              class="form-control col-md-8"
              v-model="userRegister"
              placeholder="Регистрийн дугаар тоо хэсэг"
            />
          </div>
        </div>

        <div>
          <Recaptcha
            ref="recap"
            @checkRecaptcha="checkRecaptcha"
            @recaptchaError="recaptchaError"
          />
        </div>
        <div class="forget-form forget-btn">
          <input
            type="submit"
            class="forget-btn-inner"
            value="ХАЙХ"
            :disabled="isDisabled"
          />
          <span class="forget-btn-inner" @click="redirect">БОЛИХ</span>
        </div>
        <div class="form-item form-error-out" v-if="error">
          <div class="form-error">
            <div class="error-icon">
              <img src="@/assets/icon/error.png" alt="" />
            </div>
            <div class="error-message">
              <p>{{ errorMessage }}</p>
            </div>
          </div>
        </div>
      </form>
      <Step1
        v-if="step == 1"
        @addStep="change"
        :userdata="userData"
        @redirect="redirect"
        :userToken="userToken"
        @sendedValue="sendedValue"
      ></Step1>
      <Step2
        v-if="step == 2"
        @addStep="change"
        @redirect="redirect"
        @transferToStep3="handleTransferToStep3"
        :userSendValue="userSendValue"
        :userToken="userToken"
      ></Step2>
      <Step3
        v-if="step == 3"
        @finish="finish"
        @redirect="redirect"
        :userToken="userToken"
        :cardHolderId="cardHolderId"
      ></Step3>
      <transition name="fade">
        <Error
          :errorMessage="errorMessage"
          v-if="errorModal"
          @hideErrorMessage="hideErrorMessage"
        ></Error>
      </transition>
    </b-container>
  </div>
</template>

<script>
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import EventBus from "@/EventBus.js";
import Recaptcha from "./VueRecaptcha";
import letterJSON from "@/json/data.vue";
export default {
  name: "forget",
  data() {
    return {
      step: 0,
      error: false,
      status: "",
      cardId: "",
      phoneNumber: "",
      userRegister: "",
      registerNo1: "",
      registerNo2: "",
      letters: letterJSON.myJson,
      errorMessage: "",
      userSendedType: "",
      errorModal: false,
      isDisabled: false,
      userSendValue: "",
      userData: {},
      userToken: "",
      cardHolderId: "",
      captchaItem: {
        captchaImage: "",
        captchaToken: "",
        captchaInput: "",
      },
      validateRecaptcha: false,
      isBusiness: false,
    };
  },
  created() {
    // this.captcha();
  },
  methods: {
    refresh() {
      this.$axiosApi
        .post(`system/searchinfo/before`)
        .then((response) => {
          if (response.status == 200) {
            if (response.data.status == 0) {
              this.captchaItem.captchaImage =
                "data:image/png;base64," + response.data.captcha;
              this.captchaItem.captchaToken = response.data.token;
            }
          }
        })
        .catch(() => {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        });
    },
    handleTransferToStep3(stringValue, token) {
      this.cardHolderId = stringValue; // Store the string value
      this.userToken = token;
    },

    RedirectLogin() {
      EventBus.$emit("GLOBAL_ERROR", "error");
    },

    //find user
    findUser() {
      var username = this.cardId.length > 0 ? this.cardId : this.phoneNumber;
      var userRegister = this.userRegister;
      var registerNo1 = this.registerNo1;
      var registerNo2 = this.registerNo2;
      var isNum = /^\d+$/.test(username);
      // var isNumReg = /^\d+$/.test(userRegister);
      var cardId = this.cardId.replace(/\s/g, "");
      var phoneNumber = this.phoneNumber.replace(/\s/g, "");

      if (cardId.length <= 0 && phoneNumber.length <= 0) {
        this.error = true;
        this.errorMessage =
          "Картын дугаар юм уу эсвэл утасны дугаар оруулна уу!";
        return;
      }
      if (userRegister.length < 6) {
        this.error = true;
        this.errorMessage = "Регистрын дугаар оруулна уу!";
        return;
      }
      if (isNum) {
        userRegister = registerNo1 + registerNo2 + userRegister;
        if (cardId.length > 0) {
          this.$refs.recap.checkSubmit(cardId, userRegister, true);
        } else {
          this.$refs.recap.checkSubmit(phoneNumber, userRegister, false);
        }
      }
    },
    checkRecaptcha(response) {
      this.userData = response.data;
      this.response = response;
      this.change();
    },
    recaptchaError(message) {
      this.errorMessage = message;
      this.error = true;
    },
    //change step
    change() {
      this.step++;
    },
    //sendedvalue
    sendedValue(value) {
      this.userSendValue = value;
    },
    //finsh step
    finish() {
      this.step = 0;
    },
    //redirect to login
    redirect() {
      this.$router.push({ name: "login" });
    },
    //check username name user input
    checkusername() {
      var username = this.cardId;
      var isnum = /^\d+$/.test(username);
      if (!isnum) {
        this.error = true;
        this.errorMessage = "Та зөвхөн тоо оруулна уу ?";
        this.isDisabled = true;
      } else {
        this.error = false;
        this.errorMessage = "";
        this.isDisabled = false;
      }
    },
    validate(success) {
      this.validateRecaptcha = success;
    },
  },
  components: {
    Step1,
    Step2,
    Step3,
    Recaptcha,
  },
};
</script>
<style>
.business-checkbox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.business-checkbox div {
  display: flex;
  align-items: center;
  gap: 13px;
}
.business-checkbox input:checked + label {
  color: #1660ab;
}
.error-enter-active,
.error-leave-active {
  transition: opacity 0.5s;
}
.error-enter, .error-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
@media only screen and (max-width: 400px) {
  .login-form {
    width: 300px;
  }
  .form-item input {
    width: 100%;
  }
  .form-last-text {
    flex-direction: column;
  }
  .form-last-text a {
    text-align: left;
  }
  .form-img img {
    width: 100%;
  }
}
.margin-top {
  margin-top: 10px;
}
.forget-title {
  font-size: 24px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: #1660ab;
  margin-top: 89px;
}
.forget-title p {
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 0.3px;
  text-align: center;
  color: #666666;
  margin-top: 15px;
  margin-bottom: 0;
}
.forget-form .form-control {
  padding: 0.375rem 0.25rem;
}
.myRegister {
  display: flex;
  flex-direction: row;
}
.forget-form {
  margin-top: 10px;
  margin-top: 40px;
}
.forget-form ::placeholder {
  font-size: 11px;
  color: #bdbdbd !important;
}
.forget-form .form-control {
  font-size: 12px !important;
  margin: 0;
}
.form-width {
  width: 250px !important;
  margin-top: 1px;
}
.required {
  margin: 1px;
  /* display: inline-block; width:20%; */
}
.register-from {
  margin-bottom: 12px;
  margin-right: 1%;
}
.forget-btn {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 40px;
}
.forget-btn-inner {
  flex: 0.48;
  height: 46px;
  border-radius: 5px !important;
  background-color: #1660ab;
  border: none;
  font-size: 13px !important;
  font-weight: bold !important;
  font-style: normal;
  font-stretch: normal;
  color: #ffffff;
  display: flex !important;
  align-items: center;
  justify-content: center;
}
.forget-btn-inner:nth-child(2) {
  background: #b7b7b7;
}
.forget-checkbox {
  width: 280px;
  height: 40px;
}
.forget-checkbox p {
  margin-bottom: 0;
}
.forget-user-email,
.forget-user-phone {
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.69;
  letter-spacing: normal;
  color: #000000;
}
.forget-checkbox label p:nth-child(2) {
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.69;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.6);
}
.forget-checkbox input:checked ~ .forget-user-phone {
  color: #2196f3;
}
.refresh-icon {
  width: 20px;
  cursor: pointer;
  float: right;
  margin-top: 4%;
}
</style>
